import type { IntlShape } from '@atlassian/jira-intl';

import messages from './messages';

export const validate =
	(formatMessage: IntlShape['formatMessage']) =>
	(currentValue: string): string | undefined => {
		if (Number.isNaN(Number(currentValue))) {
			return formatMessage(messages.isNotANumber);
		}

		return undefined;
	};
